<template>
  <!--コンテンツ-->
  <main class="renew3_top">
    <!--メインバナー-->
    <div class="mv">
      <div class="renew3_wrapper mv_wrapper">
        <a href="" class="mv_link">
          <img
            src="/static/renew3_img/top20250124.png"
            alt="コンビニ印刷"
            class="mv_img"
          />
        </a>
      </div>
    </div>

    <!--テンプレート選択-->
    <div class="format">
      <div class="renew3_wrapper format_wrapper">
        <!--テンプレートブロック-->
        <div class="format_block format_block1">
          <!--<h3 class="format_block_h3"></h3>-->

          <div class="flex format_block_flex">
            <a
              href="/format/rirekisho_job_change"
              id="toplnk_rirekisho_job_change"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_job_change.png"
                  alt="転職用の履歴書（JIS規格）テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3 format_link_h3big">転職履歴書</h3>
                <p class="format_link_txt">（JIS規格）</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/shokumukeirekisho"
              id="toplnk_shokumukeirekisho"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4／複数枚</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="職務経歴書"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div
                class="format_link_bottom format_link_bottom1 format_link_bottom2"
              >
                <h3 class="format_link_h3 format_link_h3big">職務経歴書</h3>
                <p class="format_link_txt">編年体式(時系列)</p>
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_job_new"
              id="toplnk_rirekisho_job_new"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_job_new.png"
                  alt="新卒履歴書"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">新卒履歴書</h3>
                <p class="format_link_txt">職歴欄なしでアピール欄広め</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rerekisho_part_time"
              id="toplnk_rerekisho_part_time"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_part_time.png"
                  alt="アルバイト用の履歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">アルバイト履歴書</h3>
                <p class="format_link_txt">勤務曜日・勤務期間記入可能</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/ai/interview_practice"
              id="toplnk_interview_practice"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <!--<p class="format_link_memo">A4／複数枚</p>-->
                <img
                  src="/static/renew3_img/format_aiinterview_fortop.png"
                  alt="AIと面接練習"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">AIと面接練習</h3>
                <p class="format_link_txt">チャット形式でいつでも可能</p>
              </div>
              <button class="format_btn format_btn3">面接練習する</button>
            </a>
            <a
              href="/format/rirekisho_ai_career"
              id="toplnk_rirekisho_ai_career"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_job_change_ai.png"
                  alt="転職用のAI履歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">転職AI履歴書</h3>
                <p class="format_link_txt">JIS規格・AI機能強化</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_job_change2"
              id="toplnk_rirekisho_job_change2"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_job_change2.png"
                  alt="転職用の履歴書（職歴欄短め）テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">職歴欄短め履歴書</h3>
                <p class="format_link_txt">社会人経験少なめの方向け</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_job_change_old"
              id="toplnk_rirekisho_job_change_old"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_job_change.png"
                  alt="転職用の履歴書（旧 JIS規格）テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">旧JIS規格履歴書</h3>
                <p class="format_link_txt">通勤時間や扶養者情報欄あり</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_job_new_single"
              id="toplnk_rirekisho_job_new_single"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／1枚</p>
                <img
                  src="/static/img/formats/rirekisho_single_new.png"
                  alt="新卒用A4一枚で書ける履歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">新卒1枚で書ける履歴書</h3>
                <p class="format_link_txt">職歴欄なしでコンパクト</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/internship"
              id="toplnk_internship"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_job_new.png"
                  alt="インターンシップ用の履歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">インターンシップ履歴書</h3>
                <p class="format_link_txt">職歴欄なしでアピール欄広め</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_part_time2"
              id="toplnk_rirekisho_part_time2"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_part_time2.png"
                  alt="パート（パートタイム）用の履歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">パート履歴書</h3>
                <p class="format_link_txt">勤務曜日・勤務期間記入可能</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_single"
              id="toplnk_rirekisho_single"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／1枚</p>
                <img
                  src="/static/img/formats/rirekisho_single.png"
                  alt="A4一枚で書ける履歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">A4一枚で書ける履歴書</h3>
                <p class="format_link_txt">コンパクトなレイアウト</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_nophoto_double"
              id="toplnk_rirekisho_nophoto_double"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/rirekisho_nophoto_double.jpg"
                  alt="証明写真なしの履歴書（職歴欄長め）テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">証明写真なしの履歴書（長）</h3>
                <p class="format_link_txt">写真なし、経歴欄が長め</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_nophoto"
              id="toplnk_rirekisho_nophoto"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／1枚</p>
                <img
                  src="/static/img/formats/rirekisho_nophoto.png"
                  alt="証明写真なしの履歴書（職歴欄短め）テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">証明写真なしの履歴書（短）</h3>
                <p class="format_link_txt">写真なし、経歴欄が短め</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
            <a
              href="/format/rirekisho_design_001"
              id="toplnk_rirekisho_design_001"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／2枚</p>
                <img
                  src="/static/img/formats/sample/rirekisho_design_001_01.jpg"
                  alt="新デザイン履歴書(beta)テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom1">
                <h3 class="format_link_h3">新デザイン履歴書(beta)</h3>
                <p class="format_link_txt">一味違うデザイン</p>
              </div>
              <button class="format_btn">この履歴書でつくる</button>
            </a>
          </div>
        </div>

        <!--テンプレートブロック-->
        <div class="format_block format_block2">
          <h3 class="format_block_h3 format_block_h3_2">職務経歴書</h3>
          <p class="format_block_lead">
            ※コンビニ印刷は、最大8ページ(白黒A4両面4枚)まで対応
          </p>

          <div class="flex format_block_flex">
            <a href="/format/sales_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="営業職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">営業職の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/service_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">販売・サービス職の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/plan_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">企画職の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/webdesign_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">Webデザイナーの職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/nurse_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">看護師の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/marketing_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">マーケティング職の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/engineer_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">SE・IT系技術職の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/electric_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">電気・機械系技術職の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/finance_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">経理の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/hr_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">人事の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/affairs_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">総務の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/office_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">一般事務職の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/legal_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">法務の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/ir_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">広報IRの職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/research_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">リサーチ職の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/technology_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">
                  メディカル・化学・食品開発系の職務経歴書
                </h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/pharmacist_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">薬剤師の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a
              href="/format/physical_therapist_shokumukeirekisho"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">理学療法士の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a
              href="/format/occupational_therapist_shokumukeirekisho"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">作業療法士の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a
              href="/format/speech_hearing_therapist_shokumukeirekisho"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">言語聴覚療法士の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a
              href="/format/nutritionist_shokumukeirekisho"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">栄養士の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a
              href="/format/construction_shokumukeirekisho"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">
                  各種施工管理技士（現場監督）の職務経歴書
                </h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/driver_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">ドライバーの職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a
              href="/format/nursing_care_shokumukeirekisho"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">介護職(介護福祉士)の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a
              href="/format/dental_hygienist_shokumukeirekisho"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">歯科衛生士の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/childminder_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">保育士の職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/other_shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">一般的な職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
            <a href="/format/shokumukeirekisho" class="format_link">
              <!--テンプレート上段-->
              <div class="format_link_top format_link_top2">
                <p class="format_link_memo">A4</p>
                <img
                  src="/static/img/formats/shokurekisho-min.png"
                  alt="販売・サービス職の職務経歴書テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom format_link_bottom2">
                <h3 class="format_link_h3">職務経歴書</h3>
                <!--<p class="format_link_txt">（JIS規格）</p>-->
              </div>
              <button class="format_btn format_btn2">この経歴書でつくる</button>
            </a>
          </div>
        </div>

        <!--テンプレートブロック-->
        <div class="format_block format_block3">
          <h3 class="format_block_h3">送付状</h3>

          <div class="flex format_block_flex">
            <a
              href="/format/letter"
              id="toplnk_rirekisho_job_change"
              class="format_link"
            >
              <!--テンプレート上段-->
              <div class="format_link_top">
                <p class="format_link_memo">A4／1枚</p>
                <img
                  src="/static/img/formats/sample/yagish_letter_img.jpeg"
                  alt="送付状テンプレート"
                  class="format_link_img"
                />
              </div>

              <!--テンプレート下段-->
              <div class="format_link_bottom">
                <h3 class="format_link_h3">送付状</h3>
                <!--<p class="format_link_txt"></p>-->
              </div>
              <button class="format_btn format_btn3">この送付状をつくる</button>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--ヤギッシュのサービス-->
    <div class="service">
      <div class="renew3_wrapper service_wrapper">
        <h3 class="service_h3">ヤギッシュのサービス</h3>

        <div class="service_list">
          <div class="service_item">
            <p class="service_item_title">履歴書を作成して、</p>
            <div class="flex service_img_list">
              <img
                src="/static/renew2_img/service01.png"
                alt="PDFで出力&amp;メール送信"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service02.png"
                alt="コンビニ印刷"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service03.png"
                alt="バックアップ＆復元"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service04.png"
                alt="自動でブラウザ保存"
                class="service_img_item"
              />
            </div>
          </div>

          <div class="service_item">
            <p class="service_item_title">履歴書を作成中、</p>
            <div class="flex service_img_list">
              <img
                src="/static/renew2_img/service09.png"
                alt="AIに文章作成"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service08.png"
                alt="フォント切り替え"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service11.png"
                alt="専属エージェント"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service07.png"
                alt="推薦書付き履歴書"
                class="service_img_item"
              />
            </div>
          </div>

          <div class="service_item">
            <p class="service_item_title">履歴書を作成後、</p>
            <div class="flex service_img_list">
              <img
                src="/static/renew2_img/service10.png"
                alt="AIと面接練習"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service05.png"
                alt="履歴書送信サービス"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service12.png"
                alt="オファーサービス"
                class="service_img_item"
              />
              <img
                src="/static/renew2_img/service06.png"
                alt="転職相談就職支援"
                class="service_img_item"
              />
            </div>
          </div>
        </div>

        <div class="flex formatbtn_list">
          <a
            href="/format/rirekisho_job_change"
            class="formatbtn_link formatbtn_link1"
            >履歴書をつくる</a
          >
          <a
            href="/format/shokumukeirekisho"
            class="formatbtn_link formatbtn_link2"
            >経歴書をつくる</a
          >
          <a href="/format/letter" class="formatbtn_link formatbtn_link3"
            >送付状をつくる</a
          >
        </div>
      </div>
    </div>

    <!--お問い合わせ-->
    <div class="contact">
      <div class="renew3_wrapper contact_wrapper">
        <div class="flex contact_list">
          <a
            href="https://www.yagish.jp/contact/"
            target="_blank"
            class="pc contact_link"
          >
            <span>パートナーについての</span><br />相談をする</a
          >
          <a href="/contact" class="contact_link">
            <span>履歴書作成についての</span><br />お問い合わせ</a
          >
          <a
            href="https://www.yagish.jp/contact/"
            target="_blank"
            class="sp contact_link"
          >
            <span>パートナーについての</span><br />相談をする</a
          >
        </div>
      </div>
    </div>

    <!--バナー-->
  </main>
</template>
<style scoped>
/*共通*/
.renew3_top .renew3_wrapper {
  width: 768px;
  margin: 0 auto;
  padding: 0 10px;
}

/*MV*/
.renew3_top .mv {
  margin-bottom: 20px;
}

.renew3_top .mv_img {
  width: 768px;
  max-width: 100%;
  margin-top: 0px;
}

/*テンプレート選択*/
.renew3_top .format {
  margin-bottom: 50px;
}

.renew3_top .format_block {
  margin-bottom: 30px;
}

.renew3_top .format_block_h3 {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.renew3_top .format_block_h3_2 {
  margin-bottom: 0;
}

.renew3_top .format_block_lead {
  font-size: 14px;
  margin-bottom: 20px;
}

.renew3_top .format_block_flex {
  justify-content: space-between;
  flex-wrap: wrap;
}

.renew3_top .format_link {
  width: calc(100% / 3 - 15px);
  margin-top: 20px;
}

.renew3_top .format_link:nth-of-type(1),
.renew3_top .format_link:nth-of-type(2),
.renew3_top .format_link:nth-of-type(3) {
  margin-top: 0;
}

.renew3_top .format_link:nth-of-type(3n-1):nth-last-of-type(1) {
  margin-right: auto;
}

.renew3_top .format_link:hover {
  transform: scale(1.04);
  text-decoration: none;
  opacity: 1;
}

.renew3_top .format_link_top {
  position: relative;
  text-align: center;
  background: #eef5e8;
  border-radius: 5px 5px 0 0;
  height: 80px;
  overflow: hidden;
}

.renew3_top .format_link_top2 {
  background: #fef5f1;
}

.renew3_top .format_link_memo {
  position: absolute;
  display: inline-block;
  font-weight: bold;
  font-size: 10px;
  color: #e95b10;
  background: #ffffff;
  border: 1px solid #e95b10;
  padding: 0 10px;
  margin-right: 5px;
  border-radius: 25px;
  top: 5px;
  left: 5px;
}

.renew3_top .format_link_img {
  display: block;
  width: 90%;
  padding-top: 10px;
  margin: 0 auto;
}

.renew3_top .format_link_bottom {
  background: #eef5e8;
  padding: 10px;
  height: 70px;
}

.renew3_top .format_link_bottom2 {
  background: #fef5f1;
}

.renew3_top .format_link_h3 {
  font-weight: bold;
  font-size: 16px;
  color: #004d40;
}

.renew3_top .format_link_txt {
  font-size: 12px;
}

.renew3_top .format_btn {
  width: 100%;
  padding: 10px;
  border: none;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background: #0f9934;
  border-radius: 0 0 5px 5px;
}

.renew3_top .format_btn:hover {
  opacity: 1;
}

.renew3_top .format_btn2 {
  background: #e95b10;
}

.renew3_top .format_btn3 {
  background: #004d40;
}

/*サービス*/
.renew3_top .service {
  margin-bottom: 50px;
  background: #eef5e8;
  padding: 50px 0;
}

.renew3_top .service_h3 {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}

.renew3_top .service_item {
  margin-bottom: 30px;
}

.renew3_top .service_item_title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}

.renew3_top .service_img_list {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.renew3_top .service_img_item {
  width: 100px;
  height: auto;
  margin-right: 8px;
}

.renew3_top .formatbtn_list {
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.renew3_top .formatbtn_link {
  width: calc(100% / 3 - 5px);
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  padding: 8px 0;
  border: 3px solid #0f9934;
  border-radius: 50px;
  background: #0f9934;
}

.renew3_top .formatbtn_link:hover {
  transform: scale(1.03);
  text-decoration: none;
  opacity: 1;
}

.renew3_top .formatbtn_link2 {
  border: 3px solid #e95b10;
  background: #e95b10;
}

.renew3_top .formatbtn_link3 {
  border: 3px solid #004d40;
  background: #004d40;
}

/*お問い合わせ*/
.renew3_top .contact {
  margin-bottom: 50px;
}

.renew3_top .contact_list {
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.renew3_top .contact_link {
  width: calc(50% - 5px);
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  line-height: 1.4;
  padding: 10px 0;
  border: 3px solid #0f9934;
  border-radius: 5px;
}

.renew3_top .contact_link:hover {
  background: #c7deb3;
  text-decoration: none;
  opacity: 1;
}

.renew3_top .contact_link span {
  font-size: 14px;
}

/*SP*/
@media screen and (max-width: 640px) {
  /*共通*/
  .renew3_top .renew3_wrapper {
    width: 100%;
  }

  /*フォーマット選択*/
  .renew3_top .format_link {
    width: calc(50% - 10px);
  }

  .renew3_top .format_link:nth-of-type(3) {
    margin-top: 20px;
  }

  .renew3_top .format_link_bottom1 {
    height: 90px;
  }

  .renew3_top .format_link_h3 {
    font-size: 14px;
  }

  .renew3_top .format_btn {
    font-size: 14px;
  }

  /*ヤギッシュのサービス*/
  .renew3_top .service_item:last-child {
    margin-bottom: 50px;
  }

  .renew3_top .service_img_item {
    margin-top: 8px;
  }

  .renew3_top .service_img_item:nth-of-type(1),
  .renew3_top .service_img_item:nth-of-type(2),
  .renew3_top .service_img_item:nth-of-type(3) {
    margin-top: 0;
  }

  .renew3_top .service_img_item:nth-of-type(3n-1):nth-last-of-type(1) {
    margin-right: auto;
  }

  .renew3_top .formatbtn_link {
    width: 250px;
    margin: 0 auto 15px;
  }

  .renew3_top .formatbtn_link:last-child {
    margin-bottom: 0;
  }

  /*お問い合わせ*/
  .renew3_top .contact_link {
    width: 100%;
    margin-bottom: 15px;
  }

  .renew3_top .contact_link:last-child {
    margin-bottom: 0;
  }

  .renew3_top .format_link_h3big {
    font-size: 16px;
  }
}

.renew3_top .mv_link:hover {
  opacity: 1;
}
</style>
<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
export default {
  components: {
    'blog-widget': blogWidget,
    'yagi-omikuji': YagiOmikuji,
    Slick
  },
  data: function () {
    return {
      is_not_midnight: true,
      recentEdit: {
        FormatId: ''
      },
      isWhat: true,
      isWho: false,
      selectedKind: '',
      selectedHash: '',
      mvBanner: 1,
      slickOptions: {
        centerMode: true,
        // centerPadding: '-20px',
        variableWidth: false,
        accessibility: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 4000,
        asNavFor: '.slider-nav',
        speed: 400
      },
      slickNavOptions: {
        focusOnSelect: true,
        asNavFor: '.slider-for',
        variableWidth: false,
        slidesToShow: 5,
        centerPadding: '20px'
      }
    }
  },
  methods: {
    searchHash: function (_hash) {
      this.selectedHash = _hash
    },
    searchKind: function (_kind) {
      this.selectedKind = _kind
    },
    reload: function () {
      location.reload(true)
    },
    recentEditClass: function (format) {
      if (!this.recentEdit) return
      if (this.recentEdit.FormatId === format.id) {
        return {
          'current-edit': true
        }
      }
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    updateRecentEdit: function (data) {
      if (data) {
        this.recentEdit = data
      }
    },
    toggleButton: function () {
      if (this.isWhat) {
        this.isWhat = false
        this.isWho = true
      } else {
        this.isWhat = true
        this.isWho = false
      }
      this.selectedKind = ''
      this.selectedHash = ''
    },
    getSelectedHash: function (classname, val) {
      if (val == this.selectedHash) {
        return classname + ' select'
      } else {
        return classname
      }
    },
    getSelectedKind: function (classname, val) {
      if (val == this.selectedKind) {
        return classname + ' select'
      } else {
        return classname
      }
    }
  },
  computed: {
    forSearchHashs: function () {
      const _rtVal = []
      if (this.selectedHash) {
        for (const obj of this.$site.rirekishoFormatsIndex) {
          for (const _hash of obj.hashs) {
            if (_hash == this.selectedHash) {
              _rtVal.push(obj)
            }
          }
        }
        return _rtVal
      } else {
        return this.$site.rirekishoFormatsIndex
      }
    }
  },
  created: function () {
    // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
    this.loadRecentEdit()
    const now = new Date()
    if (now.getHours() >= 0 && now.getHours() < 6) {
      this.is_not_midnight = false
    }
    this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$on('reload', this.reload)
  },
  destroyed: function () {
    this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$off('reload', this.reload)
  }
}
</script>
